export default {
  newCouponsCenterFrom: '', // 来源路由
  isCouponsShow: false// 兑换券包弹窗是否展示
}
